import { I18NLanguage } from './i18n-language';

export class I18NLanguageMapper {
    static mapLanguage(desiredLanguage: string): I18NLanguage {
        switch (desiredLanguage) {
            case I18NLanguage.english:
                return desiredLanguage;
            default:
                return I18NLanguage.english;
        }
    }
}
